import { useState } from 'react'

import logoFullLightPunchout from '@/assets/images/logo-full-light-punchout.png'
import * as styles from '@/styles/OnboardingScreen.css'

import { AccountConfirmationStep } from './AccountConfirmationStep'
import { EmailVerificationStep } from './EmailVerificationStep'
import { SignUpStep } from './SignUpStep'

export function OnboardingScreen() {
  const [activeStep, setActiveStep] = useState(0)
  const [customerInfoUuid, setCustomerInfoUuid] = useState<string | null>(null)
  const [email, setEmail] = useState<string>('')
  const [isAccountSetupComplete, setIsAccountSetupComplete] = useState(false)

  const handleSignUpComplete = (customerInfoId: string, userEmail: string) => {
    setCustomerInfoUuid(customerInfoId)
    setEmail(userEmail)
    // Move to email verification step
    setActiveStep(1)
  }

  const handleEmailVerificationComplete = () => {
    // Move to account confirmation step
    setActiveStep(2)
  }

  const handleAccountSetupComplete = () => {
    setIsAccountSetupComplete(true)
  }

  const renderCurrentStep = () => {
    // Step 0: Sign Up
    if (activeStep === 0) {
      return <SignUpStep onComplete={handleSignUpComplete} />
    }

    // Step 1: Email Verification
    if (activeStep === 1) {
      if (customerInfoUuid && email) {
        return (
          <EmailVerificationStep
            email={email}
            customerInfoId={customerInfoUuid}
            onComplete={handleEmailVerificationComplete}
          />
        )
      }
      return <div>Loading...</div>
    }

    // Step 2: Account Confirmation (or completed state)
    if (activeStep === 2 || isAccountSetupComplete) {
      if (customerInfoUuid) {
        return <AccountConfirmationStep customerInfoUuid={customerInfoUuid} onComplete={handleAccountSetupComplete} />
      }
      return <div>Loading...</div>
    }

    // Fallback
    return <div>Loading...</div>
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <header className={styles.header}>
          <img src={logoFullLightPunchout} alt="Sidekick Platform" className={styles.logo} />
        </header>

        <div className={styles.stepperCard}>
          <div className={styles.stepContent}>{renderCurrentStep()}</div>
        </div>
      </div>
    </div>
  )
}
